import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Dialog, DialogTitle, TextField} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, {useState} from "react";
import {Wheel} from "@uiw/react-color";
import {MAIN_BACKGROUND_COLOR} from "../CONSTANTS";
import ntc from "ntcjs";
import Button from "@mui/material/Button";
import {Option} from "../core/Option";
import {useSnackbar} from "notistack";

interface IProps{

    open: boolean;
    handleClose: () => void;
    handleSave: (option: Option) => void;

}

export default function AddOptionPopup(props: IProps)
{
    const { open, handleClose, handleSave } = props;

    const { enqueueSnackbar } = useSnackbar();

    const [name, setName] = useState<string>("");
    const [color, setColor] = useState<string>(MAIN_BACKGROUND_COLOR);

    const handleAdd = () => {
        if(name.length === 0)
        {
            enqueueSnackbar("Please enter a name first", { variant: "error" });
            return;
        }


        const option = new Option(name, color);

        handleSave(option);
    }

    return (
        <Dialog onClose={() => handleClose()} open={open} sx={{maxWidth: 'inherit', minWidth: '400px'}}>
                <DialogTitle sx={{textAlign: 'center', fontWeight: 'bold', fontSize: '15px'}}>Add option</DialogTitle>
                <Box sx={{position: 'absolute', right: '8px', top: '8px'}} onClick={() => handleClose()} >
                    <CloseIcon />
                </Box>
            <Box sx={{
                maxWidth: 'inherit',
                minWidth: '335px',
                width: '70vw',
            }}>
                <Box sx={{ width: '80%', margin: 'auto', py: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4}}>
                    <TextField variant={"standard"} fullWidth={true} value={name} label={'Name'} onChange={(e) => setName(e.target.value)} />
                    <Wheel color={color} onChange={(colorRes) => setColor(colorRes.hex)} />
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                        <Box sx={{ width: '75px', height: '25px', backgroundColor: color, border: '2px solid #c3c3c3', borderRadius: 3 }} />
                        <Typography>{ ntc.name(color)[1] }</Typography>
                    </Box>
                </Box>
            </Box>

            <Button variant={'contained'} sx={{borderRadius: 0, height: '50px'}} onClick={() => handleAdd()}>
                Add
            </Button>

        </Dialog>
    )

}